module.exports = __webpack_public_path__ + "static/media/rga_regensburg.8e983526.jpeg";